module.exports = "<div class=\"counter-digit\">0</div>";
